<template>
  <div
    v-if="model?.last_call_session"
    data-cy="last-call-column"
    class="flex min-w-50 flex-col"
  >
    <div
      class="flex items-center space-x-2 cursor-pointer"
      @click="
        openActivityModal({
          model,
          activeTypes: [CommunicationType.call],
          isAllActivity,
        })
      "
    >
      <icon-base :icon="IconTelephone" class="flex-none text-green-500" />
      <avatar-with-name
        v-if="model?.last_call_session.user"
        :user="model?.last_call_session.user"
        :text-to-size-ratio="0.58"
        data-cy="last-call-column-user-name"
      />
    </div>
    <div class="text-label" data-cy="last-call-column-date">
      <date-and-time-display
        :value="model?.last_call_session?.created_at || ''"
        :show-time-below-date="false"
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script setup lang="ts">
import { useActivityModal } from "@/composables/useActivityModal";
import { CommunicationType } from "@/enums/communicationLogs";

import IconTelephone from "@/components/icons/IconTelephone.vue";
import AvatarWithName from "@/components/ui/AvatarWithName.vue";
import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";

import type { IApplication } from "@/models/applications";

const { model, isAllActivity = false } = defineProps<{
  model?: Pick<IApplication, "id" | "last_call_session">;
  isAllActivity?: boolean;
}>();

const { openActivityModal } = useActivityModal();
</script>
